import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export type SnackSeverity = 'success' | 'error' | 'info' | 'warning';

interface SnackbarState {
  open: boolean;
  message: string;
  severity: SnackSeverity;
}

const initialState: SnackbarState = { open: false, message: '', severity: 'info' };

const snackbarSlice = createSlice({
  name: 'snackbar',
  initialState,
  reducers: {
    showSnackbar: (state, { payload }: PayloadAction<{ message: string; severity?: SnackSeverity }>) => {
      state.open = true;
      state.message = payload.message;
      state.severity = payload.severity ?? 'info';
    },
    hideSnackbar: (state) => { state.open = false; },
  },
});

export const { showSnackbar, hideSnackbar } = snackbarSlice.actions;
export default snackbarSlice.reducer;
